import { HorizontalDivider, Icon, Typography } from '@smartgift/frontend-toolkit';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ADD_TAG_STEPS } from '@hero/components/modals/AddTagModal/constant';
import { DoubleTagTable } from '@hero/organisms';

import * as S from './style';

function AddTagTable({
  setStep,
  setFooterProps,
  setModalHeader,
  onRequestClose,
  selectedRows,
  onChangeSelectedRows,
  isModal
}) {
  const { t } = useTranslation();

  useEffect(() => {
    setFooterProps({
      leftButtonText: t('cancel'),
      leftButtonOnClick: () => onRequestClose(false),
      isLeftButtonActive: true,
      isRightButtonActive: true,
      rightButtonOnClick: async () => {
        setStep(ADD_TAG_STEPS.REVIEW_TAGS);
      },
      rightButtonText: t('next'),
      rightButtonEndIcon: <Icon name="next" />
    });
    setModalHeader({ title: t('addTags') });
  }, []);

  return (
    <S.AddTagTableWrapper>
      <Typography variant="body1Bold">{t('addAdditionalTableDesc')}</Typography>
      <HorizontalDivider $height={1} $margin="8px 0" />
      <DoubleTagTable
        selectable
        showAddTags={false}
        selectedRows={selectedRows}
        onChangeSelectedRows={tags => onChangeSelectedRows(tags)}
        isModal={isModal}
      />
    </S.AddTagTableWrapper>
  );
}

export { AddTagTable };
